import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type ProjectHasDependentsErrorOptions = {
  project: ObjectId;
  sites: ObjectId[];
  privateGateways: ObjectId[];
  ipnsRecords: ObjectId[];
};

export class ProjectHasDependentsError extends FleekError<ProjectHasDependentsErrorOptions> {
  public name = 'ProjectHasDependentsError';

  toString = () => {
    const dependentsInfo: string[] = [];

    if (this.data.sites.length > 0) {
      dependentsInfo.push(`${this.data.sites.length} sites`);
    }

    if (this.data.privateGateways.length > 0) {
      dependentsInfo.push(`${this.data.privateGateways.length} private gateways`);
    }

    if (this.data.ipnsRecords.length > 0) {
      dependentsInfo.push(`${this.data.ipnsRecords.length} IPNS records`);
    }

    return `Project has assigned ${dependentsInfo.join(', ')}. You have to delete them first.`;
  };
}
